import { DeleteOutline, EditOutlined } from "@mui/icons-material";

export const TableActions = [
  {
    key: "EDIT",
    label: "Edit",
    icon: (
      <EditOutlined
        fontSize="small"
        sx={(theme) => ({
          color:
            theme.palette.mode === "dark"
              ? theme.palette.common.white
              : theme.palette.grey[500],
        })}
      />
    ),
  },
  {
    key: "DELETE",
    label: "Delete",
    icon: <DeleteOutline fontSize="small" sx={{ color: "primary.main" }} />,
  },
] as const;
